import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { SideMenuStateService } from '@services/side-menu-state.service';

/**
 * Hamburger do header das páginas.
 * Desktop (menu fixo): colapsa/expande o menu lateral. Mobile: abre o menu overlay.
 */
@Component({
    selector: 'menu-toggle-button',
    template: `
        <ion-button *ngIf="CanCollapse; else overlayButton" fill="clear" [color]="color" class="menu-toggle-button"
            [title]="(Collapsed ? 'Expandir menu' : 'Colapsar menu') + ' (Ctrl+B)'"
            [attr.aria-label]="Collapsed ? 'Expandir menu' : 'Colapsar menu'"
            [attr.aria-expanded]="!Collapsed" (click)="OnToggle()">
            <ion-icon slot="icon-only" name="menu-outline"></ion-icon>
        </ion-button>

        <ng-template #overlayButton>
            <ion-menu-button [color]="color"></ion-menu-button>
        </ng-template>`,
    styles: [`:host { display: contents; }`]
})
export class MenuToggleButtonComponent implements OnInit, OnDestroy {

    @Input() color: string;

    public Collapsed: boolean = false;

    public CanCollapse: boolean = false;

    private subs: Subscription[] = [];

    constructor(private SideMenuStateService: SideMenuStateService) { }

    ngOnInit() {
        this.subs.push(
            this.SideMenuStateService.Collapsed.subscribe(collapsed => this.Collapsed = collapsed),
            this.SideMenuStateService.PaneVisible.subscribe(visible => this.CanCollapse = visible)
        );
    }

    ngOnDestroy() {
        this.subs.forEach(sub => sub.unsubscribe());
    }

    public OnToggle() {
        this.SideMenuStateService.Toggle();
    }
}
